import { Icon } from './index'

export const Copy: Icon = ({ variant = '', xs }) => (
	<svg
		className={variant}
		width={xs ? '16' : '24'}
		height={xs ? '16' : '24'}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			stroke="currentColor"
			strokeLinejoin="round"
			strokeWidth="2"
			d="M9 8v3a1 1 0 0 1-1 1H5m11 4h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v1m4 3v10a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-7.13a1 1 0 0 1 .24-.65L7.7 8.35A1 1 0 0 1 8.46 8H13a1 1 0 0 1 1 1Z"
		/>
	</svg>
)
